export function roundRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  radius: { tl: number; tr: number; br: number; bl: number },
) {
  ctx.beginPath();
  ctx.moveTo(x + radius.tl, y);
  ctx.lineTo(x + width - radius.tr, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
  ctx.lineTo(x + width, y + height - radius.br);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
  ctx.lineTo(x + radius.bl, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
  ctx.lineTo(x, y + radius.tl);
  ctx.quadraticCurveTo(x, y, x + radius.tl, y);
  ctx.closePath();
}

export function peach(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  color: string,
  isSmall = false,
) {
  ctx.beginPath();
  ctx.fillStyle = color;
  if (isSmall) {
    ctx.moveTo(x, y - 2);
    ctx.bezierCurveTo(x - 5, y + 6.5, x - 6.5, y + 9, x, y + 10);
    ctx.moveTo(x, y - 2);
    ctx.bezierCurveTo(x + 5, y + 6.5, x + 6.5, y + 9, x, y + 10);
  } else {
    ctx.moveTo(x, y - 2);
    ctx.bezierCurveTo(x - 10, y + 13, x - 13, y + 18.5, x, y + 19);
    ctx.moveTo(x, y - 2);
    ctx.bezierCurveTo(x + 10, y + 13, x + 12, y + 18.5, x, y + 19);
  }
  ctx.fill();
}
